exports.USER_LOGGED_OUT = '310';
exports.USER_UNAUTHORIZED = '401';



// WEBPACK FOOTER //
// ./src/constants/statusCodes.js